"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
exports.Container = {
    fontFamily: "-apple-system,\n                BlinkMacSystemFont,\n                \"Segoe UI\",\n                Roboto,\n                \"Helvetica Neue\",\n                Arial,\n                sans-serif,\n                \"Apple Color Emoji\",\n                \"Segoe UI Emoji\",\n                \"Segoe UI Symbol\"",
    fontWeight: '400',
    lineHeight: '1.5',
    color: '#212529',
    textAlign: 'left',
    paddingLeft: '15px',
    paddingRight: '15px',
};
exports.NavBar = {
    position: 'relative',
    border: '1px solid transparent',
    borderColor: '#e7e7e7',
};
exports.NavRight = {
    textAlign: 'right',
};
exports.Nav = {
    margin: '7.5px',
};
exports.NavItem = {
    display: 'inline-block',
    padding: '10px 5px',
    lineHeight: '20px',
};
exports.NavButton = {
    display: 'inline-block',
    padding: '6px 12px',
    marginTop: '8px',
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderRadius: '4px',
    color: '#333',
    backgroundColor: '#fff',
    borderColor: '#ccc',
};
exports.FormContainer = {
    textAlign: 'center',
};
exports.FormSection = {
    marginBottom: '20px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    textAlign: 'left',
    width: '400px',
    display: 'inline-block',
};
exports.ErrorSection = {
    marginBottom: '20px',
    color: '#fff',
    backgroundColor: '#f0ad4e',
    border: '1px solid #eea236',
    borderRadius: '4px',
    textAlign: 'left',
};
exports.SectionHeader = {
    color: '#fff',
    backgroundColor: '#337ab7',
    borderColor: '#337ab7',
    padding: '10px 15px',
    borderBottom: '1px solid transparent',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
    textAlign: 'center',
};
exports.SectionFooter = {
    color: '#333',
    backgroundColor: '#f5f5f5',
    padding: '10px 15px',
    borderTop: '1px solid #ddd',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
};
exports.SectionBody = {
    padding: '15px',
};
exports.FormRow = {
    marginBottom: '15px',
};
exports.ActionRow = {
    marginBottom: '15px',
};
exports.Input = {
    display: 'block',
    width: '100%',
    height: '34px',
    padding: '6px 12px',
    fontSize: '14px',
    lineHeight: '1.42857143',
    color: '#555',
    backgroundColor: '#fff',
    backgroundImage: 'none',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075)',
    boxSizing: 'border-box',
    transition: 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
};
exports.Button = {
    display: 'inline-block',
    padding: '6px 12px',
    marginBottom: '0',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    backgroundImage: 'none',
    border: '1px solid transparent',
    borderRadius: '4px',
    color: '#333',
    backgroundColor: '#fff',
    borderColor: '#ccc',
};
exports.SignInButton = {
    position: 'relative',
    padding: '6px 12px 6px 44px',
    fontSize: '14px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '100%',
    marginTop: '2px',
    '#google_signin_btn': {
        color: '#fff',
        backgroundColor: '#dd4b39',
        borderColor: 'rgba(0,0,0,0.2)',
    },
    '#facebook_signin_btn': {
        color: '#fff',
        backgroundColor: '#3b5998',
        borderColor: 'rgba(0,0,0,0.2)',
    },
};
exports.Space = {
    display: 'inline-block',
    width: '20px',
};
exports.A = {
    color: '#007bff',
    cursor: 'pointer',
};
exports.Pre = {
    overflow: 'auto',
    fontFamily: "Menlo,\n                Monaco,\n                Consolas,\n                \"Courier New\",\n                monospace",
    display: 'block',
    padding: '9.5px',
    margin: '0 0 10px',
    fontSize: '13px',
    lineHeight: '1.42857143',
    color: '#333',
    wordBreak: 'break-all',
    wordWrap: 'break-word',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ccc',
    borderRadius: '4px',
};
exports.Col1 = {
    display: 'inline-block',
    width: '8.33333333%',
};
exports.Col2 = {
    display: 'inline-block',
    width: '16.66666667%',
};
exports.Col3 = {
    display: 'inline-block',
    width: '25%',
};
exports.Col4 = {
    display: 'inline-block',
    width: '33.33333333%',
};
exports.Col5 = {
    display: 'inline-block',
    width: '41.66666667%',
};
exports.Col6 = {
    display: 'inline-block',
    width: '50%',
};
exports.Col7 = {
    display: 'inline-block',
    width: '58.33333333%',
};
exports.Col8 = {
    display: 'inline-block',
    width: '66.66666667%',
};
exports.Col9 = {
    display: 'inline-block',
    width: '75%',
};
exports.Col10 = {
    display: 'inline-block',
    width: '83.33333333%',
};
exports.Col11 = {
    display: 'inline-block',
    width: '91.66666667%',
};
exports.Col12 = {
    display: 'inline-block',
    width: '100%',
};
exports.Hidden = {
    display: 'none',
};
exports.Bootstrap = {
    container: exports.Container,
    navBar: exports.NavBar,
    nav: exports.Nav,
    navRight: exports.NavRight,
    navItem: exports.NavItem,
    navButton: exports.NavButton,
    formContainer: exports.FormContainer,
    formSection: exports.FormSection,
    errorSection: exports.ErrorSection,
    sectionHeader: exports.SectionHeader,
    sectionBody: exports.SectionBody,
    sectionFooter: exports.SectionFooter,
    formRow: exports.FormRow,
    actionRow: exports.ActionRow,
    space: exports.Space,
    signInButton: exports.SignInButton,
    input: exports.Input,
    button: exports.Button,
    a: exports.A,
    pre: exports.Pre,
    col1: exports.Col1,
    col2: exports.Col2,
    col3: exports.Col3,
    col4: exports.Col4,
    col5: exports.Col5,
    col6: exports.Col6,
    col7: exports.Col7,
    col8: exports.Col8,
    col9: exports.Col9,
    col10: exports.Col10,
    col11: exports.Col11,
    col12: exports.Col12,
    hidden: exports.Hidden,
};
/**
 * @deprecated use named import
 */
exports.default = exports.Bootstrap;
//# sourceMappingURL=AmplifyTheme.js.map